import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import {
  GenerateKentRebalancingPlanParams,
  KentRebalancingAccepted,
} from '@cast/types';

import { getKentRebalancePlanQueryKey } from 'hooks/queries/rebalancer/useKentRebalancePlansQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useGenerateKentRebalancePlanMutation = (
  clusterId: string
): UseMutationResult<
  AxiosResponse<KentRebalancingAccepted>,
  unknown,
  GenerateKentRebalancingPlanParams,
  unknown
> => {
  const { currentOrganization } = useOrganizations();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params) =>
      apiClient.kent.generateRebalancingPlan(
        {
          organizationId: currentOrganization?.id ?? '',
          clusterId,
          createRebalancingPlanRequest: params,
        },
        { timeout: 60_000 }
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getKentRebalancePlanQueryKey(clusterId),
      });
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
